import React from "react";

export default function DialogContainer({
    renderDialogContent
}) {
    return (
        renderDialogContent && renderDialogContent()
    )
}